import type { TextUIPart, ToolInvocation, ToolInvocationUIPart } from '@ai-sdk/ui-utils';
import { AGENTS, getDefaultAgent, isBoltAgent, isClaudeCodeAgent, userCanUseClaudeCodeAgent } from '~/lib/agents';
import type { ChatHistoryItem } from '~/lib/persistence/chats';
import { chatStore } from '~/lib/stores/chat';
import { projectStore } from '~/lib/stores/project';
import { userStore } from '~/lib/stores/user';
import type { UserData } from '~/types/user';

export interface ToolInvocationGroupUIPart {
  toolInvocations: ToolInvocation[];
  type: 'tool-invocation-group';
}

export function isToolInvocationPart(part?: { type: string }): part is ToolInvocationUIPart {
  return part?.type === 'tool-invocation';
}

export function isToolInvocationGroupPart(part?: { type: string }): part is ToolInvocationGroupUIPart {
  return part?.type === 'tool-invocation-group';
}

export function isTextPart(part?: { type: string }): part is TextUIPart {
  return part?.type === 'text';
}

export function isTodoWritePart(part?: {
  type: string;
  toolInvocation?: { toolName: string };
}): part is ToolInvocationUIPart & {
  toolInvocation: { toolName: 'TodoWrite' };
} {
  return isToolInvocationPart(part) && part.toolInvocation?.toolName === 'TodoWrite';
}

export function getAgentForChat(chat?: ChatHistoryItem, user?: UserData) {
  if (chat && isClaudeCodeAgent(chat.agent) && userCanUseClaudeCodeAgent(user)) {
    return AGENTS.ClaudeCode;
  }

  return AGENTS.Bolt;
}

export function getAgentForCurrentChat() {
  const projectId = projectStore.getProjectId();
  const user = userStore.getUser();

  if (!projectId) {
    return getDefaultAgent(user);
  }

  const chat = chatStore.findChatByProjectId(projectId);

  if (!chat) {
    console.error('No chat found for project id', projectId);
    return getDefaultAgent(user);
  }

  return getAgentForChat(chat, user);
}

export function isCurrentChatUsingClaudeCode() {
  const agent = getAgentForCurrentChat();

  return isClaudeCodeAgent(agent);
}

export function isCurrentChatUsingBoltAgent() {
  const agent = getAgentForCurrentChat();

  return isBoltAgent(agent);
}
